import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  name: string;
  location: string;
  avatar: string;
  quote: React.ReactNode;
};
const TESTIMONIALS: Testimonial[] = [{
  name: 'Yulimar Soto',
  location: 'Miami, FL',
  avatar: 'https://cdn.magicpatterns.com/uploads/3XicfY418qsfiurahtwYxz/627d56d5e5f0724eccce67347be05b08.jpg',
  quote: <>
        "Venía de perder dinero con otras agencias que no hicieron absolutamente
        nada. Estaba muy escéptica, pero el{' '}
        <strong data-id="element-380">acompañamiento y la estrategia</strong> marcaron la diferencia.
        Por fin una compañía que toma el proceso en serio.{' '}
        <strong data-id="element-381">Los recomiendo a ciegas.</strong>"
      </>
}, {
  name: 'Ricardo Peña',
  location: 'Orlando, FL',
  avatar: 'https://cdn.magicpatterns.com/uploads/acv3HmNGFJQvXAgZAGSdyf/dfe2f8fe7df795a79c175033606fe398.jpg',
  quote: <>
        "Traté de organizar mi crédito solo y <strong data-id="element-382">perdí mi tiempo</strong>.
        Con Brixen entendí mi situación y seguimos un plan claro. La{' '}
        <strong data-id="element-383">atención y la comunicación</strong> han sido excelentes en todo
        momento."
      </>
}, {
  name: 'Adriana Lugo',
  location: 'Queens, NY',
  avatar: 'https://cdn.magicpatterns.com/uploads/oH2wh44rhZ9JNhW3AtL8cb/15c825ecdbba179c03db28b552b723d0.jpg',
  quote: <>
        "Tenía muchas dudas sobre mi reporte y no sabía por dónde empezar.{' '}
        <strong data-id="element-384">Me explicaron todo paso a paso</strong> y siempre estuvieron
        disponibles para mis preguntas.{' '}
        <strong data-id="element-385">Lo que dicen lo cumplen.</strong>"
      </>
}, {
  name: 'Marcos Velez',
  location: 'Houston, TX',
  avatar: 'https://cdn.magicpatterns.com/uploads/mSXVSGzY8taf6BG23xshKK/76ba5989c19fd1dcb2efc73368cd91d8.jpg',
  quote: <>
        "Yo era de los que pensaba que esto era puro cuento hasta que vi cómo
        trabajan. Me activé con un <strong data-id="element-386">plan a mi medida</strong> y el equipo
        me mantuvo informado en cada etapa del proceso."
      </>
}, {
  name: 'Mónica Solano',
  location: 'Los Angeles, CA',
  avatar: 'https://cdn.magicpatterns.com/uploads/p2hro3wVHwGjny7gn9p4g5/041066f09440fdc4be5c9bcfe8d523cf.jpg',
  quote: <>
        "Quedé sorprendida con la <strong data-id="element-387">velocidad del proceso</strong> y la
        atención al cliente. Hicieron un trabajo increíble guiándome con mi
        crédito. <strong data-id="element-388">¡Mil gracias!</strong>"
      </>
}, {
  name: 'Isabela Duarte',
  location: 'Charlotte, NC',
  avatar: 'https://cdn.magicpatterns.com/uploads/cNEhqKqxmyZKPiW1YfLZHT/e1f78072cb65663ad41b03209320195c.jpg',
  quote: <>
        "Si vienen referidos como yo, no lo piensen dos veces. El{' '}
        <strong data-id="element-389">soporte que te dan es excelente</strong>, siempre están
        pendientes de todo. <strong data-id="element-390">Los recomiendo 100%.</strong>"
      </>
}];
export function Testimonios() {
  return <section className="w-full bg-[#F5F5F5] py-14 md:py-20 px-5" data-id="element-391">
      <div className="max-w-6xl mx-auto" data-id="element-392">
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-393">
          <h2 className="text-2xl md:text-4xl font-extrabold text-[#0A0A0A] mb-4" style={{
          fontFamily: 'Manrope, Inter, sans-serif'
        }} data-id="element-394">
            ¿Por Qué Somos la Compañía{' '}
            <span className="text-[#7B2FE0]" data-id="element-395">Más Confiable</span> de Habla
            Hispana?
          </h2>
          <p className="text-base text-gray-600" data-id="element-396">
            Nuestra mejor publicidad es la satisfacción de nuestros clientes.
            Mira lo que dicen nuestros clientes activos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-397">
          {TESTIMONIALS.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col" data-id="element-398">
              <div className="flex flex-col items-center text-center mb-4" data-id="element-399">
                <img src={t.avatar} alt={t.name} className="w-20 h-20 rounded-full object-cover object-top mb-3 border-2 border-gray-100" data-id="element-400" />
                <div className="flex mb-2" data-id="element-401">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} className="w-4 h-4 text-[#00B67A] fill-[#00B67A]" data-id="element-402" />)}
                </div>
                <p className="font-bold text-[#0A0A0A]" style={{
              fontFamily: 'Manrope, Inter, sans-serif'
            }} data-id="element-403">
                  {t.name}
                </p>
                <p className="text-xs text-gray-500" data-id="element-404">{t.location}</p>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed text-center" data-id="element-405">
                {t.quote}
              </p>
            </motion.div>)}
        </div>

        <p className="text-center text-xs text-gray-400 mt-8" data-id="element-406">
          Resultados individuales. Las experiencias varían según cada caso.
        </p>
      </div>
    </section>;
}